import React, { useState } from "react";
import Profile_Bg from "../../Assets/Images/Profile_BG.png";
import { BiEditAlt } from "react-icons/bi";
import EditProfileModal from "../../components/AdminSideComponents/EditProfileModal";

const Profile = () => {
  const [openEditModal, setOpenEditModal] = useState(false);
  const userDetails = localStorage.getItem("yostelPG-userData");
  const userData = JSON.parse(userDetails);
  console.log("User Data: ", userData);
  return (
    <div className="p-2 sm:p-4 md:p-6 tracking-wide">
      {/* Edit Profile Modal  */}
      {openEditModal && (
        <EditProfileModal
          onClose={() => setOpenEditModal(false)}
          userData={userData}
        />
      )}
      <div
        style={{ backgroundImage: `url(${Profile_Bg})` }}
        className="bg-cover bg-center bg-no-repeat h-48 sm:h-64 md:h-72 lg:h-[20rem] bg-white mb-4 rounded-lg flex justify-center items-center flex-col gap-1 text-white relative shadow-lg"
      >
        <button
          className="bg-blue-700 font-bold text-white absolute top-2 hover:bg-blue-800 right-2 px-2 py-2 rounded-lg text-xs flex items-center gap-1 "
          onClick={() => setOpenEditModal(true)}
        >
          Edit Profile <BiEditAlt />
        </button>
        <img
          src={userData?.profilePic}
          alt="No Image"
          className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 object-cover rounded-full"
        />
        <h1 className="font-semibold text-base sm:text-lg md:text-xl tracking-wider">
          {userData?.name}
        </h1>
        <p className="font-extralight text-sm sm:text-base font-mono tracking-widest">
          {userData?.userType}
        </p>
      </div>

      <div className="w-full my-4 p-4 sm:p-6 rounded-lg shadow-lg bg-blue-50">
        <h1 className="text-lg md:text-[22px] font-semibold text-primaryTextColor my-2">
          Personal Info
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ">
          {[
            { label: "Aadhaar Number", value: userData?.adhaarNumber || "N/A" },
            { label: "Phone Number", value: userData?.phoneNumber || "N/A" },
            { label: "Email", value: userData?.email || "N/A" },
            { label: "Gender", value: userData?.gender || "N/A" },

            {
              label: "Date of Birth",
              value: userData?.dateOfBirth.slice(0, 10) || "N/A",
            },
            { label: "Nationality", value: userData?.nationality || "N/A" },
            { label: "Address", value: userData?.address || "N/A" },
            { label: "City", value: userData?.city || "N/A" },
            { label: "State", value: userData?.state || "N/A" },
            // { label: "", value: userData?. || "N/A" },
          ].map((item, index) => (
            <div
              className="flex flex-col xl:flex-row xl:gap-4 mb-2 xl:items-center text-gray-600 text-base sm:text-lg font-medium "
              key={index}
            >
              {item.label} :
              <span className={`${item.label === "Email" ? "" : "capitalize"}`}>
                {item.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Profile;
